import React from "react";
import styled from "styled-components";
import { darken } from "polished";
import { Dropdown } from "react-bootstrap";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { variantToColour } from "../../helpers/theme";

const Menu = ({ children, styles = { maxWidth: '14rem' } } : Readonly<{ 
    children: React.ReactNode
    styles?: React.CSSProperties
}>) => (
    <Dropdown.Menu style={styles}>
        {children}
    </Dropdown.Menu>
);

const MenuHeader = styled(Dropdown.Header)`
    color: ${(props: any) => variantToColour(props)};
`;

const MenuItemWrapper = styled(Dropdown.Item)`
    color: ${(props: any) => variantToColour(props)};
    &:hover {
        color: ${(props: any) => darken(0.1, variantToColour(props))};
    }
`;

const MenuItem = ({ icon, onClick, text, variant = 'dark' } : Readonly<{
    icon: IconProp
    onClick?: () => void | null
    text: any,
    variant?: ThemeVariant
}>) => (
    <MenuItemWrapper variant={variant} onClick={onClick}>
        <FontAwesomeIcon icon={icon} size="sm" /> <span className="ms-1">{text}</span>
    </MenuItemWrapper>
);

export default {
    Menu,
    MenuHeader,
    MenuItem
}